import { Link } from 'react-router-dom';
import { Menu, X, Sparkles } from 'lucide-react';
import { useState } from 'react';

export function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/20 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
          >
            <div className="relative">
              <Sparkles className="w-6 h-6 text-primary group-hover:text-primary-light transition-colors" />
            </div>
            <span className="font-heading text-2xl text-primary group-hover:text-primary-light transition-colors">
              SoulSeer
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className="text-foreground hover:text-primary transition-colors font-body text-sm"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-foreground hover:text-primary transition-colors font-body text-sm"
            >
              About
            </Link>
            <Link 
              to="/readers" 
              className="text-foreground hover:text-primary transition-colors font-body text-sm"
            >
              Find Readers
            </Link>
            <Link 
              to="/shop" 
              className="text-foreground hover:text-primary transition-colors font-body text-sm"
            >
              Shop
            </Link>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="text-foreground hover:text-primary transition-colors font-body text-sm"
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="bg-primary hover:bg-primary-dark text-background px-4 py-2 rounded-lg font-body text-sm transition-all duration-300 gold-glow"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-foreground hover:text-primary transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="md:hidden pb-4 border-t border-border/20">
            <div className="flex flex-col gap-3 pt-4">
              <Link 
                to="/" 
                className="text-foreground hover:text-primary transition-colors font-body"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="text-foreground hover:text-primary transition-colors font-body"
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/readers" 
                className="text-foreground hover:text-primary transition-colors font-body"
                onClick={() => setIsOpen(false)}
              >
                Find Readers
              </Link>
              <Link 
                to="/shop" 
                className="text-foreground hover:text-primary transition-colors font-body"
                onClick={() => setIsOpen(false)}
              >
                Shop
              </Link>
              <div className="flex gap-2 pt-2">
                <Link
                  to="/login"
                  className="flex-1 text-center text-foreground hover:text-primary transition-colors font-body py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Sign In
                </Link>
                <Link
                  to="/signup"
                  className="flex-1 bg-primary hover:bg-primary-dark text-background px-4 py-2 rounded-lg font-body transition-all text-center"
                  onClick={() => setIsOpen(false)}
                >
                  Get Started
                </Link>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
